import styled from "styled-components";

import { getBorderRadius, getSemanticColor, getBorderWidth } from "@braze/beacon-styling";

export const StyledBrazeOperatorLaunchButton = styled.button`
  & {
    background:
      radial-gradient(100% 100% at var(--80-x-position) var(--80-y-position), #c8edff 0%, transparent),
      radial-gradient(100% 100% at var(--81-x-position) var(--81-y-position), #ffa4fb 0%, transparent),
      radial-gradient(100% 100% at var(--82-x-position) var(--82-y-position), #6826e1 0%, transparent), #1b253b;
    border-radius: ${getBorderRadius("round")};
    transition-timing-function: ease-in-out;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 26px;
      height: 25px;
    }

    &:hover {
      animation-name: braze-operator-launch-button-animation;
      animation-iteration-count: 1;
      animation-duration: 2s;
    }

    &:focus-visible:not(:disabled) {
      outline: ${getBorderWidth("thick")} solid ${getSemanticColor("accent-border-active")};
      /* prevents the outline from getting covered by adjacent elements */
      position: relative;
    }
  }

  @property --80-x-position {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 87.578125%;
  }
  @property --80-y-position {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 87.8125%;
  }
  @property --81-x-position {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 16.718750000000004%;
  }
  @property --81-y-position {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 20.976562499999996%;
  }
  @property --82-x-position {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 27.851562500000004%;
  }
  @property --82-y-position {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 73.75%;
  }

  @keyframes braze-operator-launch-button-animation {
    50% {
      --80-x-position: 15%;
      --80-y-position: 15%;
      --81-x-position: 85%;
      --81-y-position: 80%;
      --82-x-position: 20%;
      --82-y-position: 20%;
    }
  }
`;
